export default __webpack_public_path__ + "static/media/BUGSHAN.03bdbf38.png";